export class AgmMapMarker {
    name: string;
    markerid: number;
    consolid: number;
    lat: number;
    lng: number;
    label: string;
    iconurl: string;
    draggable: boolean;
    markercontent: string;
    address: string;
    postalcode: string;
    served: boolean;
    status: string;
    forecastdeliverydate: string;
    note: string;
}
